import React, { useContext } from 'react'

import Provider, { TermsAcceptanceContextProvider, TermsAcceptanceContext } from './Provider'
import { PointrThemedContainer } from 'components'
import useTermsAcceptance from './Styles'
import { NotificationPage } from 'components'
import { Paper, Button } from '@material-ui/core'
import ReactHtmlParser from 'react-html-parser'
import ConfirmAction from '../confirm-action/View'
import RequirePasswordDialog from '../require-password-dialog/View'
import { ITermsAcceptanceProps } from './Interfaces'

const TermsAcceptancePage: React.FC = () => {
  const classes = useTermsAcceptance({})
  const { state, handlers } = useContext<TermsAcceptanceContext>(TermsAcceptanceContextProvider)

  return (
    <RequirePasswordDialog onSubmitPassword={handlers.rejectTerms}>
      {(isRequirePasswordDialogOpen: boolean, toggleRequirePasswordDialog: () => void) => (
        <PointrThemedContainer withGradientNavbar={true} withBeansBackground={false}>
          <div className={classes.root}>
            <div className={classes.container}>
              <NotificationPage
                warning
                size="small"
                title="Terms of Service and Privacy Policy"
                subtitle="Please accept to continue using Pointr. If you choose to reject, your data will be removed from out database."
              />

              <Paper className={classes.termsPaper}>
                <div className={classes.termsContent}>
                  <div className={classes.terms}>
                    {ReactHtmlParser(state.termsAndConditions)}
                    {ReactHtmlParser(state.privacyPolicy)}
                  </div>
                </div>
                <p id="terms-acceptance-page-description-label" className={classes.bottomMessage}>
                  By accepting these terms you agree with all the content here described.
                </p>
              </Paper>
              <div className={classes.actionsBar}>
                <ConfirmAction
                  title="You must agree with the terms to continue"
                  content="If you choose to reject, your profile and all your data will be deleted"
                  onConfirm={toggleRequirePasswordDialog}
                >
                  {(isDialogOpen: boolean, toggleDialog: () => void) => {
                    return (
                      <Button
                        id="terms-acceptance-page-reject-button"
                        onClick={toggleDialog}
                        disabled={state.isLoadingData || isDialogOpen}
                      >
                        Reject
                      </Button>
                    )
                  }}
                </ConfirmAction>
                <Button
                  id="terms-acceptance-page-accept-button"
                  onClick={handlers.acceptTerms}
                  variant="contained"
                  disabled={state.isLoadingData || isRequirePasswordDialogOpen}
                >
                  Accept
                </Button>
              </div>
            </div>
          </div>
        </PointrThemedContainer>
      )}
    </RequirePasswordDialog>
  )
}

export default (props: ITermsAcceptanceProps) => (
  <Provider {...props}>
    <TermsAcceptancePage />
  </Provider>
)
